import React from 'react';
import { Box, Divider, IconButton } from '@material-ui/core';
import { ExpandLess, ExpandMore, VpnKey } from '@material-ui/icons';
import { LoanKey } from '../../redux/loans/models/Loan';
import { mediumDate, mediumTime } from 'src/helpers/datetime';

type PropsStatusDrawer = {
  showStatus: boolean;
  setShowStatus: any;
  list: LoanKey[];
};

const StatusDrawer = ({
  showStatus,
  setShowStatus,
  list,
}: PropsStatusDrawer) => (
  <>
    {list?.length < 1 ? (
      <Box>Sin llaves</Box>
    ) : (
      <>
        <Box>
          Que llaves?
          <IconButton size='medium' onClick={() => setShowStatus(!showStatus)}>
            {!showStatus ? <ExpandMore /> : <ExpandLess />}
          </IconButton>
        </Box>
        {showStatus && (
          <Box>
            {list.map((item: any, i) => (
              <div key={i}>
                <Divider />
                <Box
                  sx={{
                    display: 'flex',
                    mb: 1,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <b style={{ marginRight: 5 }}>
                    {item.property_nid}
                    <br />
                    {item.barcode}:
                  </b>
                  {item.type_keys_str}
                  <IconButton>
                    <VpnKey />
                  </IconButton>
                  <br />
                  <div>
                    {item.status_loan_keys_str ? item.status_loan_keys_str : ''}
                    <br />
                    {item.return_date && (
                      <div>
                        <b>
                          Fecha{' '}
                          {item.status_loan_keys_id == '2' ? 'de entrega' : ''}
                          {item.status_loan_keys_id == '4'
                            ? 'de transferencia'
                            : ''}
                          :
                        </b>{' '}
                        <br />
                        {mediumDate(item.return_date, '-')}{' '}
                        {mediumTime(item.return_date, '-')}
                      </div>
                    )}
                  </div>
                </Box>
              </div>
            ))}
          </Box>
        )}
      </>
    )}
  </>
);

export default StatusDrawer;
